import React, { useState, useEffect } from 'react'
import { Button, Form, Input, Select, Switch, Tabs, Alert } from 'antd'
import { SaveOutlined } from '@ant-design/icons'
import { apiRequest } from '../../helpers'

const apiUrl = process.env.REACT_APP_API

const MODELS = [
  { value: 'gpt-4o', label: 'GPT-4o' },
  { value: 'gpt-4o-mini', label: 'GPT-4o Mini' },
  { value: 'gpt-4.1', label: 'GPT-4.1' },
  { value: 'gpt-4', label: 'GPT-4' },
  { value: 'o3', label: 'O3' },
]

const TpmExcelAgentConfig = () => {
  const [aiConnectors, setAiConnectors] = useState([])
  const [saving, setSaving] = useState(false)
  const [success, setSuccess] = useState(false)
  const [error, setError] = useState(null)
  const [aiContext, setAiContext] = useState('')
  const [form] = Form.useForm()

  useEffect(() => {
    fetchAgent()
    fetchAiConnectors()
  }, [])

  const fetchAgent = async () => {
    const res = await apiRequest(`${apiUrl}tpm/excel-agent`, 'GET')
    if (res?.data) {
      form.setFieldsValue({
        name: res.data.name || 'Excel Structure Agent',
        aiConnectorId: res.data.aiConnectorId || undefined,
        aiModel: res.data.aiModel || 'gpt-4o',
        previewRows: res.data.previewRows || 10,
        active: res.data.active ?? true,
      })
      setAiContext(res.data.aiContext || '')
    }
  }

  const fetchAiConnectors = async () => {
    const res = await apiRequest(`${apiUrl}connector/ai?limit=100`, 'GET')
    if (res?.data?.data) setAiConnectors(res.data.data.filter(c => c.active))
  }

  const handleSave = async () => {
    setError(null)
    setSuccess(false)
    const values = await form.validateFields()
    setSaving(true)
    try {
      await apiRequest(`${apiUrl}tpm/excel-agent`, 'PATCH', {
        ...values,
        aiConnectorId: values.aiConnectorId ? Number(values.aiConnectorId) : null,
        previewRows: Number(values.previewRows),
        aiContext,
      })
      setSuccess(true)
      setTimeout(() => setSuccess(false), 3000)
    } catch { setError('Eroare la salvare.') }
    finally { setSaving(false) }
  }

  const tabs = [
    {
      key: 'general',
      label: 'General',
      children: (
        <Form form={form} layout="vertical">
          <div className="row g-3">
            <div className="col-md-6">
              <Form.Item label="Nume agent" name="name">
                <Input />
              </Form.Item>
            </div>
            <div className="col-md-6" style={{ display: 'flex', alignItems: 'center', paddingTop: 30 }}>
              <Form.Item name="active" valuePropName="checked" style={{ marginBottom: 0 }}>
                <Switch checkedChildren="Activ" unCheckedChildren="Inactiv" />
              </Form.Item>
            </div>
            <div className="col-md-4">
              <Form.Item label="Conector AI" name="aiConnectorId">
                <Select placeholder="-- Selecteaza --" allowClear>
                  {aiConnectors.map(c => <Select.Option key={c.id} value={c.id}>{c.name}</Select.Option>)}
                </Select>
              </Form.Item>
            </div>
            <div className="col-md-4">
              <Form.Item label="Model AI" name="aiModel">
                <Select>
                  {MODELS.map(m => <Select.Option key={m.value} value={m.value}>{m.label}</Select.Option>)}
                </Select>
              </Form.Item>
            </div>
            <div className="col-md-4">
              <Form.Item label="Randuri preview" name="previewRows" tooltip="Cate randuri din Excel sa trimita la AI pentru identificarea structurii">
                <Input type="number" min={5} max={50} />
              </Form.Item>
            </div>
          </div>
        </Form>
      ),
    },
    {
      key: 'instructions',
      label: 'Instructiuni AI',
      children: (
        <div>
          <label style={{ display: 'block', marginBottom: 8, fontWeight: 500 }}>Instructiuni pentru identificarea structurii Excel</label>
          <textarea
            className="form-control"
            rows={15}
            value={aiContext}
            onChange={e => setAiContext(e.target.value)}
            style={{ fontFamily: 'monospace', fontSize: 13, width: '100%' }}
            placeholder="Descrie agentului cum sa identifice structura coloanelor din Excel..."
          />
          <small style={{ color: '#888' }}>
            Agentul primeste primele N randuri din Excel si decide daca structura e determinista si care coloane corespund campurilor (partNumber, pret, etc.).
          </small>
        </div>
      ),
    },
  ]

  return (
    <div style={{ background: '#fff', borderRadius: 8, padding: 16, boxShadow: '0 1px 4px rgba(0,0,0,0.08)' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <div>
          <strong style={{ fontSize: 16 }}>Agent Identificare Structura Excel</strong>
          <div style={{ color: '#888', fontSize: 13, marginTop: 2 }}>
            Identifica automat coloanele din fisierele Excel mari si extrage datele determinist (fara AI per rand).
          </div>
        </div>
        <Button type="primary" icon={<SaveOutlined />} onClick={handleSave} loading={saving}>
          {saving ? 'Se salveaza...' : 'Salveaza'}
        </Button>
      </div>

      {error && <Alert message={error} type="error" showIcon style={{ marginBottom: 12 }} />}
      {success && <Alert message="Configuratie salvata cu succes!" type="success" showIcon style={{ marginBottom: 12 }} />}

      <Tabs items={tabs} />
    </div>
  )
}

export default TpmExcelAgentConfig
